import { Card, Typography, Button, Container, Stack, TableContainer, TableHead, TableRow, TableCell, Checkbox, Table, TableBody, Popover, MenuItem, IconButton, Avatar, FormControl, Select, Switch, Box, InputBase } from "@mui/material";
import { deleteData, formPostData, getData, patchFormData } from "src/webService/webService";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import '../../Common_css/style.css';
import Iconify from 'src/components/iconify';
import { toast, ToastContainer } from "react-toastify";
import Loader from "../Loader/Loader";

export default function Merchant() {

    const [open, setOpen] = useState(null);
    const [merchantArray, setMerchantArray] = useState([]);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const Token = sessionStorage.getItem('Token');
    const [loader, setLoader] = useState(false);
    const [activeStates, setActiveStates] = useState({});
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    const debounce = (func, delay) => {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const debouncedSearch = debounce((query) => {
        if (query.length >= 3 || query.length === 0) {
            setSearchQuery(query);
            getBuyerData(1, query);
        }
    }, 500);

    const getBuyerData = async (page, search = "") => {
        setLoader(true)
        const params = {
            page: page,
            per_page: limit,
            search: search
        }
        try {
            const res = await getData('buyers', params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setMerchantArray(res.data);
                setTotalItems(res?.total);
                setTotalPages(res?.last_page);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        getBuyerData(currentPage);
    }, [limit, currentPage])


    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleOpenMenu = (event, id) => {
        setOpen(event.currentTarget);
    };


    const handleLimitChange = (event) => {
        setCurrentPage(1);
        setLimit(event.target.value);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleSwitchChange = (checked, id) => {
        debugger;
        setActiveStates(prev => ({
            ...prev,
            [id]: !checked,
        }));
        const formData = new FormData();
        formData.append('isActive', checked === false ? 0 : 1)

        patchFormData(`buyers/${id}`, formData, Token)
            .then((res) => {
                getBuyerData(currentPage);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };



    return (
        <>
            <ToastContainer position="top-right" />
            <Helmet>
                <title> Buyers</title>
            </Helmet>

            <div className='p-0 BuyerPage'>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" className='title-color' gutterBottom>
                        Buyers
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            backgroundColor: "none",
                            borderRadius: "15px",
                            boxShadow: 1,
                            marginRight: "20px",
                            border: "1px solid #010101"
                        }}
                    >
                        <Iconify icon="eva:search-fill" sx={{ marginLeft: "10px" }} />
                        <InputBase
                            placeholder="Search"
                            value={searchText}
                            sx={{ marginLeft: "8px" }}
                            onChange={(e) => {
                                setSearchText(e.target.value);
                                debouncedSearch(e.target.value);
                            }}
                        />
                    </Box>
                </Stack>
                {loader ? (
                    <Loader />
                ) : (
                    <Card className='card-bg'>
                        <TableContainer style={{ height: "420px", overflowY: "scroll", width: "100%", background: '#d0e1e9' }}>
                            <Table stickyHeader style={{ width: "100%" }}>
                                <TableHead>
                                    <TableRow>
                                        {/* <TableCell className="table-cl color-dark mx-5" width='11%' align="center">
                                            Profile Picture
                                        </TableCell> */}
                                        <TableCell className="table-cl color-dark mx-15">
                                            Name
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-10">
                                            Phone Number
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-10">
                                            Email
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-10">
                                            Status
                                        </TableCell>
                                        <TableCell className="table-cl color-dark mx-10">
                                            Location
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {merchantArray?.map((item, index) => (
                                        <TableRow key={index}>
                                            {/* <TableCell className="table-cl color-dark mx-5" width='5%' align="center">
                                                
                                            </TableCell> */}
                                            <TableCell className="table-cl color-dark mx-15">
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                    gap={2}
                                                >
                                                    {item?.photo ? (
                                                        <Avatar src={item?.photo}></Avatar>
                                                    ) : (
                                                        <Avatar>
                                                            {item.name
                                                                ? item.name[0]
                                                                : null}
                                                        </Avatar>
                                                    )}
                                                    {item?.name ? item?.name : '--'}
                                                </Stack>

                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-10">
                                                {item?.phone ? item?.phone : '--'}
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-10">
                                                {item?.email ? item?.email : '--'}
                                            </TableCell>
                                            <TableCell>
                                                <Switch
                                                    checked={item?.isActive === false ? !activeStates : activeStates} // invert for your logic
                                                    onChange={(e) => handleSwitchChange(e.target.checked, item._id)}
                                                />
                                            </TableCell>
                                            <TableCell className="table-cl color-dark mx-10">
                                                {item?.location ? item?.location : '--'}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="d-flex flex-wrap justify-content-end m-3">
                            <FormControl variant="outlined" size="small" style={{ width: "6%" }}>
                                <Select
                                    labelId="limit-label"
                                    id="limit-select"
                                    value={limit}
                                    onChange={handleLimitChange}
                                >
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                    <MenuItem value={30}>30</MenuItem>
                                    <MenuItem value={TotalItems}>All</MenuItem>
                                </Select>
                            </FormControl>
                            <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                                <Iconify icon={"grommet-icons:previous"} />
                            </Button>
                            <Button
                                onClick={handleNextPage}
                                disabled={currentPage === totalPages}
                            >
                                <Iconify icon={"grommet-icons:next"} />
                            </Button>
                        </div>
                        <Popover
                            open={Boolean(open)}
                            anchorEl={open}
                            onClose={handleCloseMenu}
                            anchorOrigin={{ vertical: "top", horizontal: "left" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            PaperProps={{
                                sx: {
                                    p: 1,
                                    width: 160,
                                    "& .MuiMenuItem-root": {
                                        px: 1,
                                        typography: "body2",
                                        borderRadius: 0.75,
                                    },
                                },
                            }}
                        >
                            <MenuItem
                            // onClick={() => {
                            //     setAction("Edit");
                            //     handleOpenModal();
                            // }}
                            >
                                <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
                                Edit
                            </MenuItem>
                            <MenuItem
                            // onClick={() => {
                            //     setAction("View");
                            //     handleOpenModal();
                            // }}
                            >
                                <Iconify icon={"raphael:view"} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                            <MenuItem
                                sx={{ color: "error.main" }}
                            // onClick={() => {
                            //     handleOpenDeleteModal();
                            // }}
                            >
                                <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
                                Delete
                            </MenuItem>
                        </Popover>
                    </Card>
                )}
            </div>


        </>
    )
}